import history from 'providers/history';
import { parse, stringify } from 'query-string';
import React from 'react';
import FontAwesome from 'react-fontawesome';

interface OwnProps {
    location: Location;
}

export interface StateProps {
    isSearching: boolean;
}

export interface DispatchProps {
    searchInventory(search: any): any;
}

type CombinedProps = OwnProps & StateProps & DispatchProps;

interface IState {
    search: string;
}

class TextSearch extends React.Component<CombinedProps, IState> {
    constructor(props: CombinedProps) {
        super(props);
        this.state = {
            search: ''
        };
    }

    public componentDidMount() {
        const queryObj = parse(location.search);
        if (typeof queryObj.search === 'undefined') {
            this.setState({ search: '' });
            return;
        }
        this.setState({ search: queryObj.search });
    }

    /**
     * handle search click
     */
    public handleSearchOnClick = () => {
        this.props.searchInventory(this.state.search);
        history.push(`/inventory?${stringify({ search: this.state.search })}`);
    }

    public handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        return this.handleSearchOnClick();
    }

    public render() {
        return (
            <div className={`rounded-box d-flex flex-row bd-highlight w-100 ms`}>
                <div className="left flex-grow-1">
                    <form action="" onSubmit={this.handleSubmit}>
                    <input
                        value={this.state.search}
                        onChange={e => this.setState({ search: e.currentTarget.value })}
                        placeholder="Search By Make / Model / Year / Description"
                    />
                    </form>
                </div>
                <div className="right">
                    <FontAwesome name="search" onClick={this.handleSearchOnClick} />
                </div>
            </div>
        );
    }
}

export default TextSearch;



// WEBPACK FOOTER //
// ./src/components/global/form/TextSearch.tsx